(function () {
  function init() {
    const availableEl = document.getElementById("js-pr-available");
    const unavailableEl = document.getElementById("js-pr-unavailable");
    const invScript = document.getElementById("variant-inventory-map");

    if (!availableEl || !unavailableEl || !invScript) return;

    let invMap = null;
    try {
      invMap = JSON.parse(invScript.textContent);
    } catch (e) {
      return;
    }

    function getVariantIdFromUrl() {
      const v = new URLSearchParams(window.location.search).get("variant");
      return v ? String(v) : null;
    }

    function setState(inStock) {
      availableEl.classList.toggle("d-none", !inStock);
      unavailableEl.classList.toggle("d-none", inStock);
    }

    function updateAvailability() {
      const variantId = getVariantIdFromUrl();
      if (!variantId || !invMap || !invMap[variantId]) return;

      const data = invMap[variantId];

      // Hvis inventory ikke spores, betragt som "på lager"
      if (!data.managed) {
        setState(true);
        return;
      }

      // "På lager" = qty > 0
      // (selv hvis policy = "continue" skal vi vise "ikke på lager" ved qty <= 0)
      const qty = Number(data.qty);
      setState(Number.isFinite(qty) && qty > 0);
    }

    updateAvailability();

    // Overvåg URL ?variant=
    let lastVariant = getVariantIdFromUrl();
    setInterval(() => {
      const current = getVariantIdFromUrl();
      if (current && current !== lastVariant) {
        lastVariant = current;
        updateAvailability();
      }
    }, 200);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
